exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.homepage-grid-line-container[data-v-31527222] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-left: 1%;\r\n  margin-right: 1%;\n}\n.items-container[data-v-31527222] {\r\n  width: 100%;\n}\n.header-content[data-v-31527222] {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  color: white;\n}\r\n\r\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 1431px) {\n.header-content[data-v-31527222] {\r\n    font-size: 2rem;\n}\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31527222","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Homepage/homepageGridLine.vue
// module id = 1531
// module chunks = 2